import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AgentApi } from 'src/app/_shared/api/agent.api';
import { AgentState } from '../state/agent.state';

@Injectable({
  providedIn: 'root',
})
export class AgentService {
  constructor(private agentApi: AgentApi, private snackBar: MatSnackBar, private agentState: AgentState) { }

  getAgentList(params) {
    return new Observable((observer) => {
      observer.next({ isLoading: true });
      this.agentApi
        .getAgentList(params)
        .pipe(
          finalize(() => {
            observer.next({ isLoading: false });
            observer.complete();
          })
        )
        .subscribe(
          (res: any) => {
            if (res) {
              this.agentState.agentListValue = res;
            }
          },
          (err: any) => {
            this.agentState.agentListValue = [];
            // this.openSnackBar(err.error.message || 'Failed to fetch agent information', 'snackbar-error');
          }
        );
    });
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
}
